<template>
    <div>
        <el-dialog title="代理人信息设置" style="text-align:center" :visible="visible" :show="show" width="60%"  @close="close" :close-on-click-modal="false">
            <el-table :data="dataList"  border  style="width: 100%" height="500px">
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column prop="fullName" label="姓名"  align="center"></el-table-column>
                <el-table-column prop="account" label="账号" align="center" width="100"></el-table-column>
                <el-table-column prop="isBroken" label="是否锁定" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.islock=='1'">正常</span>
                        <span v-if="scope.row.islock=='0'">锁定</span>
                    </template>
                </el-table-column>
                <el-table-column prop="mobile" label="手机号" align="center"></el-table-column>
                <el-table-column label="代理到场地" align="center" width="400" prop="zdList">
                </el-table-column>
                <el-table-column label="操作" width="100" align="center">
                    <template slot-scope="scope">
                        <el-button type="danger" icon="el-icon-delete"  size="mini"  @click="delUserOrgRelation(scope.row)">删除 </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-dialog>


    </div>
</template>
<script>
    export default{
        name:'orgUserDetail',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
            },
            rowData(){
                if (this.show){
                    this.getUserListByOrgId();
                }
            },
        },
        data(){
            return{
                visible:false,
                dataList:[],
                userDataList:[],
                dataListSelections:[],

            }
        },
        methods:{
            close(){
                this.dataList = [];
                this.dataListSelections = [];
                this.$emit("listenToChildEvent",false);
            },

            getUserListByOrgId(){
                let params = {'searchType':'0'};
                this.$http({
                    url: `sysUserOrg/getUserListByOrgId/`+this.rowData.orgId,
                    method: "get",
                    params:params
                }).then(({ data }) => {
                    //this.dataList = data.userList;
                    let arr = data.userList;
                    this.dataList = [];
                    arr.map(item=>{
                        if (item.zdOrgIds!=null){
                            item.zdOrgIdArr = item.zdOrgIds.split(",");
                        }
                        this.dataList.push(item);
                    })
                });
            },
            delUserOrgRelation(row){
                let ids = [row.userOrgId];
                this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    this.$http({
                        url: "sysUserOrg/delete",
                        method: "post",
                        data: ids
                    }).then(({data}) => {
                        if(data && data.code === 0){
                            this.$message({
                                message: "操作成功",
                                type: "success",
                                duration: 1500,
                                onClose: () => {
                                    this.getUserListByOrgId(row.orgId);
                                }
                            });
                        }else{
                            this.$message.error(data.msg);
                        }
                    });
                });
            },

        }
    }
</script>